import Notification from 'flarum/forum/components/Notification';
import app from 'flarum/forum/app';

export default class CaseFollowUpAnsweredNotification extends Notification {
  icon() {
    return 'fas fa-comment-dots';
  }

  href() {
    const data = this.attrs.notification.content() || {};
    if (!data.discussionId) return '#';
    return app.route('discussion', { id: data.discussionId }) + (data.postNumber ? '/' + data.postNumber : '');
  }

  content() {
    const data = this.attrs.notification.content() || {};
    return 'AI 追问已回复：' + (data.title || '案例');
  }

  excerpt() {
    const data = this.attrs.notification.content() || {};
    return data.answerPreview || data.question || '';
  }
}
